import { render, staticRenderFns } from "./DeleteButton2.vue?vue&type=template&id=7f824990&scoped=true&"
var script = {}
import style0 from "./DeleteButton2.vue?vue&type=style&index=0&id=7f824990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f824990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
